const GET_ZONES: string = 'GET_ZONES';
const SET_LOADING_ZONES: string = 'SET_LOADING_ZONES';
const SET_ZONES: string = 'SET_ZONES';
const GET_ZONE: string = 'GET_ZONE';
const SET_ZONE: string = 'SET_ZONE';

export default {
  GET_ZONES,
  SET_LOADING_ZONES,
  SET_ZONES,
  GET_ZONE,
  SET_ZONE,
}